import {connect} from 'react-redux';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {dismissPinTagErrorsBanner} from '../../../../store/panels/inboxes/inboxesPanelActions';
import {makeGetPinTagBannerErrors} from '../../../../store/panels/inboxes/inboxesPanelSelectors';
import {InboxesPanelId} from '../../../../store/panels/panelStateBase';
import {PinTagErrorBanners} from './pinTagErrorsBanner';

/*
 * Props.
 */

interface PinTagErrorsBannerContainerProps {
  panelId: InboxesPanelId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<PinTagErrorsBannerContainerProps>()(() => ({
  errors: makeGetPinTagBannerErrors(),
}));

const mapDispatchToProps = makeMapDispatchToProps<PinTagErrorsBannerContainerProps>()(({panelId}) => ({
  onDismissClick: () => dismissPinTagErrorsBanner(panelId),
}));

export const PinTagErrorsBannerContainer = connect(mapStateToProps, mapDispatchToProps)(PinTagErrorBanners);
